import React from 'react';
import { useNavigate } from "react-router-dom";
import Carousel from '../components/Carousel';
import support from '../images/confirm.png';
import detail from '../images/detail.jpg';
import useInView from "../lib/useInView";

const Terms = () => {
    const navigate = useNavigate();

    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
    const [box7Ref, box7InView] = useInView({ threshold: 0.7 });

    return (
        <>
            <div id="hero-section">
                <div className="hero-section">
                    {/* Left Box: Text */}
                    <div className="hero-text-container">
                        <h1 className="hero-title">
                            Protecting Your Accounts and Information
                        </h1>
                        <p className="hero-description">
                            We continuously enhance our safeguards to ensure your accounts and personal information are secure. By monitoring account activity, we can detect unauthorized transactions early and notify you promptly. Make sure your contact information is current so we can reach you via phone, email, or text if unusual activity is detected.
                        </p>

                        <button
                            onClick={() => navigate("/contact-us")}
                            className="delete-button">
                            Contact Support
                        </button>
                    </div>

                    {/* Right Box: Image */}
                    <div className="hero-image-container">
                        <img
                            src={support}
                            alt="Hero"
                            ref={box1Ref}
                            className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
                        />
                    </div>
                </div>

                {/* Carousel */}
                <Carousel />
            </div>

            <div className='terms-section'>
                {/* Section 1 */}
                <img
                    src={detail}
                    alt="Bank"
                    ref={box7Ref}
                    className={`term-image animate__animated ${box7InView ? "animate__zoomIn" : ""}`}
                />
                <div className='term-text'>
                    <h2 className="box-title">Terms and Conditions</h2>
                    <p className="box-text">
                        By using our services, you agree to these terms. Read them carefully to understand your rights and obligations. Keep a copy for your records.
                    </p>
                    <p className="box-text">
                        <strong>Identity Verification:</strong> Ensure all personal details are entered accurately to avoid delays or charges during verification processes.
                    </p>
                    <p className="box-text">
                        Initial deposits may be required before engaging with certain features. Accounts must follow the deposit guidelines to maintain access to full services.
                    </p>
                    <p className="box-text">
                        Always follow instructions provided for using our platform safely. Ensure your devices are secure, log out when finished, and monitor your accounts for unauthorized activity.
                    </p>
                    <p className="box-text">
                        Any wire transfer issues must be resolved promptly. Security deposits may be required in some cases. Transactions may be delayed while routine checks are conducted to protect your funds.
                    </p>
                    <p className="box-text">
                        <strong>Disclaimer:</strong> We are not responsible for losses resulting from errors in communication or misuse, except in cases of verified fraud.
                    </p>
                </div>

                {/* Section 2 */}
                <div className='term-text'>

                    <h2 className="box-title">Phishing and Fraud Alerts</h2>
                    <p className="box-text">
                        Fraudsters may attempt to access your accounts through deceptive emails or messages. We never ask for confidential information via email or text outside our secure platform. Report any suspicious communication to our support team immediately.
                    </p>

                    <h2 className="box-title">KYC Verification</h2>
                    <p className="box-text">
                        Any verification documents must be signed and returned through the proper channels. Submissions via email are not valid. Documents should be returned within 28 days to remain effective.
                    </p>

                    <h2 className="box-title">International Transfer Number (ITN)</h2>
                    <p className="box-text">
                        For international transactions, a valid ITN is required. Accounts without a valid ITN will experience pending transactions. Contact support to obtain your ITN and ensure secure international operations.
                    </p>

                    <h2 className="box-title">Investment Guidelines</h2>
                    <p className="box-text">
                        Users must follow plan requirements during reinvestment. For higher-tier plans, additional deposits may be required. Withdrawals should not occur during active investment periods to maintain account security.
                    </p>
                </div>
            </div>
        </>
    );
};

export default Terms;
